import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { ApiService } from '../api/api.service';

export type PhaseOfferImageRecord = {
    id: string;
    phaseId: string;
    fileId: string;
    sortOrder: number;
    url: string;
};

@Injectable({ providedIn: 'root' })
export class PhaseOfferImagesService {
    private api = inject(ApiService);

    list(phaseId: string): Observable<PhaseOfferImageRecord[]> {
        const id = encodeURIComponent(String(phaseId || '').trim());
        return this.api.get<any>(`/API2/phases/${id}/offer-images`).pipe(
            map((resp) => {
                const rows = Array.isArray(resp?.data) ? resp.data : Array.isArray(resp?.DATA) ? resp.DATA : [];
                return rows
                    .map((r: any) => ({
                        id: String(r?.id ?? r?.ROWID ?? ''),
                        phaseId: String(r?.phase_id ?? r?.PHASE_ID ?? phaseId),
                        fileId: String(r?.file_id ?? r?.FILE_ID ?? ''),
                        sortOrder: Number(r?.sort_order ?? r?.SORT_ORDER ?? 0) || 0,
                        url: String(r?.url ?? r?.URL ?? '')
                    }))
                    .filter((row: PhaseOfferImageRecord) => Boolean(row.id && row.url));
            })
        );
    }

    add(phaseId: string, payload: { fileId: string; sortOrder?: number }): Observable<void> {
        const id = encodeURIComponent(String(phaseId || '').trim());
        const body: any = {
            file_id: String(payload.fileId || '').trim(),
            sort_order: Number.isFinite(payload.sortOrder as number) ? payload.sortOrder : 0
        };
        return this.api.post<any>(`/API2/phases/${id}/offer-images`, body).pipe(map(() => void 0));
    }

    reorder(phaseId: string, ids: string[]): Observable<void> {
        const id = encodeURIComponent(String(phaseId || '').trim());
        const body: any = { ids };
        return this.api.put<any>(`/API2/phases/${id}/offer-images/reorder`, body).pipe(map(() => void 0));
    }

    remove(phaseId: string, imageId: string): Observable<void> {
        const pid = encodeURIComponent(String(phaseId || '').trim());
        const iid = encodeURIComponent(String(imageId || '').trim());
        return this.api.delete<any>(`/API2/phases/${pid}/offer-images/${iid}`).pipe(map(() => void 0));
    }
}

